import { pendoApiKey } from '../constants';
import { ISession } from '../types';

function loadPendo() {
  (function (apiKey: string) {
    (function (p: any, e: any, n: any, d: any, o?: any) {
      let v: any;
      let w: any;
      let x: any;
      let y: any;
      let z: any;
      o = p[d] = p[d] || {};
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      }
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(pendoApiKey);
}

export function initPendo(session: ISession, additionalProperties: any) {
  if (process.env.NODE_ENV === 'test') {
    return;
  }

  loadPendo();
  const account = session.account;
  (window as any).pendo.initialize({
    excludeAllText: true,
    excludeTitle: true,

    visitor: {
      id: session.email,
      name: session.user.profile.name,
      email: session.email,
      // role:         // Optional reserved property

      // allow for additional properties to be passed in by app
      ...additionalProperties,
    },

    // account properties
    account: {
      id: account && account.id,
      name: account && account.name,
      type: account && account.type,
      app: 'jupiterone',
      // planLevel:    // Optional reserved property
      // planPrice:    // Optional reserved property

      // allow for additional properties to be passed in by app
      ...additionalProperties,
    },
  });
}
